import { render, staticRenderFns } from "./m_tech012.vue?vue&type=template&id=490c63ce&scoped=true&"
import script from "./m_tech012.vue?vue&type=script&lang=js&"
export * from "./m_tech012.vue?vue&type=script&lang=js&"
import style0 from "./m_tech012.vue?vue&type=style&index=0&id=490c63ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c63ce",
  null
  
)

export default component.exports